const customerUpdateMeQuery = require('../../queries/user/customerUpdateMeQuery');
const { clientMutate } = require('../queries');
const handleCtApiError = require('../handleCtApiError');

/**
 * @param {Context} context
 * @param {Customer} currentUser
 * @param {Address} updatedAddress
 */
const updateBillingAddress = async (context, currentUser, updatedAddress) => {
  // Validate input
  if (!updatedAddress?.id) {
    throw new Error('Updated address must include an "id" field.');
  }

  // Step 1: Build the update action
  /* eslint eslint-comments/no-use: off */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { id, __typename: _typename, ...addressInput } = updatedAddress;

  const actions = [{ changeAddress: { addressId: id, address: addressInput } }];

  // Step 2: Prepare the mutation options
  const options = {
    mutation: customerUpdateMeQuery,
    variables: {
      version: currentUser.version,
      actions,
    },
    fetchPolicy: 'no-cache',
  };

  try {
    const updateResponse = await clientMutate(context, options);

    return updateResponse;
  } catch (error) {
    throw handleCtApiError(error);
  }
};

module.exports = updateBillingAddress;
